import axios from "axios";
const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "sm_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));
const client = axios.create({ baseURL: BASE, withCredentials: true });
client.interceptors.request.use((c) => { const t = getToken(); if (t) c.headers.Authorization = `Bearer ${t}`; return c; });
export const api = {
  get: (u, c) => client.get(u, c).then((r) => r.data),
  post: (u, b, c) => client.post(u, b, c).then((r) => r.data),
  put: (u, b, c) => client.put(u, b, c).then((r) => r.data),
  del: (u, c) => client.delete(u, c).then((r) => r.data),
};
export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}
export default client;
